import React, { useState, useEffect } from "react"
import LoadSpinner from "../../LoadSpinner";
import PropTypes from "prop-types";
import $ from 'jquery';


const SvgFacebook = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.676 0H1.324C0.593 0 0 0.593 0 1.324V22.676C0 23.408 0.593 24 1.324 24H12.818V14.706H9.689V11.085H12.818V8.41C12.818 5.311 14.712 3.625 17.477 3.625C18.802 3.625 19.941 3.722 20.273 3.766V7.006H18.352C16.852 7.006 16.56 7.727 16.56 8.777V11.088H20.144L19.679 14.718H16.56V24H22.675C23.408 24 24 23.408 24 22.676V1.324C24 0.593 23.408 0 22.676 0Z"
        fill="#F1F1F1"></path>
</svg>;

const SvgFile = <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.83 2H18C19.1 2 20 2.9 20 4V16C20 17.1 19.1 18 18 18H2C0.9 18 0 17.1 0 16V4C0 2.9 0.9 2 2 2H5.17L7 0H13L14.83 2ZM2 16H18V4H13.95L12.12 2H7.88L6.05 4H2V16ZM10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM7 10C7 11.65 8.35 13 10 13C11.65 13 13 11.65 13 10C13 8.35 11.65 7 10 7C8.35 7 7 8.35 7 10Z" fill="#F1F1F1" fillOpacity="0.6"></path>
</svg>;

const SvgInstagram = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C8.74 0 8.333 0.015 7.053 0.072C5.775 0.132 4.905 0.333 4.14 0.63C3.351 0.936 2.681 1.347 2.014 2.014C1.347 2.681 0.935 3.35 0.63 4.14C0.333 4.905 0.131 5.775 0.072 7.053C0.012 8.333 0 8.74 0 12C0 15.26 0.015 15.667 0.072 16.947C0.132 18.224 0.333 19.095 0.63 19.86C0.936 20.648 1.347 21.319 2.014 21.986C2.681 22.652 3.35 23.065 4.14 23.37C4.906 23.666 5.776 23.869 7.053 23.928C8.333 23.988 8.74 24 12 24C15.26 24 15.667 23.985 16.947 23.928C18.224 23.868 19.095 23.666 19.86 23.37C20.648 23.064 21.319 22.652 21.986 21.986C22.652 21.319 23.065 20.651 23.37 19.86C23.666 19.095 23.869 18.224 23.928 16.947C23.988 15.667 24 15.26 24 12C24 8.74 23.985 8.333 23.928 7.053C23.868 5.776 23.666 4.904 23.37 4.14C23.064 3.351 22.652 2.681 21.986 2.014C21.319 1.347 20.651 0.935 19.86 0.63C19.095 0.333 18.224 0.131 16.947 0.072C15.667 0.012 15.26 0 12 0ZM12 2.16C15.203 2.16 15.585 2.176 16.85 2.231C18.02 2.286 18.655 2.48 19.077 2.646C19.639 2.863 20.037 3.123 20.459 3.542C20.878 3.962 21.138 4.361 21.355 4.923C21.519 5.345 21.715 5.98 21.768 7.15C21.825 8.416 21.838 8.796 21.838 12C21.838 15.204 21.823 15.585 21.764 16.85C21.703 18.02 21.508 18.655 21.343 19.077C21.119 19.639 20.864 20.037 20.444 20.459C20.025 20.878 19.62 21.138 19.064 21.355C18.644 21.519 17.999 21.715 16.829 21.768C15.555 21.825 15.18 21.838 11.97 21.838C8.759 21.838 8.384 21.823 7.111 21.764C5.94 21.703 5.295 21.508 4.875 21.343C4.306 21.119 3.915 20.864 3.496 20.444C3.075 20.025 2.806 19.62 2.596 19.064C2.431 18.644 2.237 17.999 2.176 16.829C2.131 15.569 2.115 15.18 2.115 11.985C2.115 8.789 2.131 8.399 2.176 7.124C2.237 5.954 2.431 5.31 2.596 4.89C2.806 4.32 3.075 3.93 3.496 3.509C3.915 3.09 4.306 2.82 4.875 2.611C5.295 2.445 5.926 2.25 7.096 2.19C8.371 2.145 8.746 2.13 11.955 2.13L12 2.16ZM12 5.838C8.595 5.838 5.838 8.598 5.838 12C5.838 15.405 8.598 18.162 12 18.162C15.405 18.162 18.162 15.402 18.162 12C18.162 8.595 15.402 5.838 12 5.838ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16ZM19.846 5.595C19.846 6.39 19.2 7.035 18.406 7.035C17.611 7.035 16.966 6.389 16.966 5.595C16.966 4.801 17.612 4.156 18.406 4.156C19.199 4.155 19.846 4.801 19.846 5.595Z" fill="#F1F1F1"></path>
</svg>;

const SvgUnauthorized = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.79 5.31641H1.21107C0.833187 5.31641 0.526855 5.62274 0.526855 6.00062C0.526855 6.3785 0.833187 6.68483 1.21107 6.68483H10.79C11.1679 6.68483 11.4742 6.3785 11.4742 6.00062C11.4742 5.62274 11.1679 5.31641 10.79 5.31641Z" fill="white"></path>
    <path d="M6.68457 10.79L6.68457 1.21107C6.68457 0.833187 6.37824 0.526855 6.00036 0.526855C5.62248 0.526855 5.31615 0.833187 5.31615 1.21107L5.31615 10.79C5.31615 11.1679 5.62248 11.4742 6.00036 11.4742C6.37824 11.4742 6.68457 11.1679 6.68457 10.79Z" fill="white"></path>
</svg>;

const SvgYoutube = <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.4951 6.20522C23.356 5.70699 23.0908 5.25305 22.725 4.88727C22.3593 4.5215 21.9053 4.25628 21.4071 4.11723C19.5371 3.61623 12.0111 3.61623 12.0111 3.61623C12.0111 3.61623 4.5041 3.60623 2.6151 4.11723C2.11686 4.25628 1.66292 4.5215 1.29715 4.88727C0.931378 5.25305 0.66615 5.70699 0.527099 6.20522C0.172619 8.11974 -0.00214065 10.0632 0.0050988 12.0102C-0.000772064 13.9499 0.173982 15.8859 0.527099 17.7932C0.66615 18.2915 0.931378 18.7454 1.29715 19.1112C1.66292 19.4769 2.11686 19.7422 2.6151 19.8812C4.4831 20.3832 12.0111 20.3832 12.0111 20.3832C12.0111 20.3832 19.5171 20.3832 21.4071 19.8812C21.9053 19.7422 22.3593 19.4769 22.725 19.1112C23.0908 18.7454 23.356 18.2915 23.4951 17.7932C23.8408 15.8852 24.0082 13.9492 23.9951 12.0102C24.0096 10.0639 23.8422 8.12043 23.4951 6.20522ZM9.6091 15.6012V8.40823L15.8731 12.0102L9.6091 15.6012Z" fill="white" fillOpacity="1"></path>
</svg>;

const SvgTikTok = <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#F1F1F1" className="bi bi-tiktok" viewBox="0 0 16 16">
    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />
</svg>;

const SourceItem = (props) => {
    const { id, isActive, sourceIcon, authorizeIcon, userProfile, onSourceSelected, onLogin, onLogout } = props;

    function handleLinkClick(e) {
        e.preventDefault();

        let link = $(e.target).parents('.icon-group');
        let idAttr = link.attr('id');
        if (idAttr) {
            let index = idAttr.replace('source-', '');
            let i = parseInt(index);
            onSourceSelected(i);
        }
    }

    function handleLoginClick(e) {
        e.preventDefault();
        onLogin(e);
    }

    function handleLogoutClick(e) {
        e.preventDefault();
        onLogout(e);
    }

    return isActive
        ? (
            <a id={id} href="/" className={`${isActive ? 'active ' : ''}icon-group social-media-icons d-flex align-items-center justify-content-center mb-3`} onClick={handleLinkClick}>
                <span className={'d-flex align-items-center justify-content-center'}>
                    {sourceIcon}
                </span>

                {
                    // ig, fb, yt
                    !!authorizeIcon ?

                        // active
                        (isActive) ?
                            <>
                                <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !props.isReady || !props.loginComplete ? 'visible' : 'hidden' }}>
                                    <div className={`spinner-border spinner-border-sm`} role="status" />
                                </small>
                                <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile || !props.isReady || !props.loginComplete ? 'hidden' : 'visible' }}>
                                    {authorizeIcon}
                                </small>
                                <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile && props.isReady && props.loginComplete ? 'visible' : 'hidden' }} onClick={handleLogoutClick}>
                                    <img alt={userProfile?.name} width="26" height="26" src={userProfile?.imageUrl ?? '/images/check-icon.svg'} style={{ objectFit: "cover", borderRadius: "50%" }} />
                                </small>
                            </> :

                            // not active
                            <>
                                <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile || !props.isReady ? 'hidden' : 'visible' }}>
                                    {authorizeIcon}
                                </small>
                                <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile && props.isReady ? 'visible' : 'hidden' }}>
                                    <img alt={userProfile?.name} width="26" height="26" src={userProfile?.imageUrl ?? '/images/check-icon.svg'} style={{ objectFit: "cover", borderRadius: "50%" }} />
                                </small>
                            </>
                        : <></>
                }
            </a>
        )

        // not active
        : (
            <a id={id} href="/" className={`${isActive ? 'active ' : ''}icon-group social-media-icons d-flex align-items-center justify-content-center mb-3`} onClick={handleLinkClick}>
                <span className={'d-flex align-items-center justify-content-center'}>
                    {sourceIcon}
                </span>
                {
                    // ig, fb, yt
                    !!authorizeIcon ?
                        <>
                            <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !props.isReady ? 'visible' : 'hidden' }}>
                                <div className={`spinner-border spinner-border-sm`} role="status" />
                            </small>
                            <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile || !props.isReady ? 'hidden' : 'visible' }}>
                                {authorizeIcon}
                            </small>
                            <small className="position-absolute add-link social-media-add-link d-flex align-items-center justify-content-center" style={{ 'visibility': !!userProfile && props.isReady ? 'visible' : 'hidden' }}>
                                <img alt={userProfile?.name} width="26" height="26" src={userProfile?.imageUrl ?? '/images/check-icon.svg'} style={{ objectFit: "cover", borderRadius: "50%" }} />
                            </small>
                        </> : <></>
                }
            </a>
        );
}

SourceItem.propTypes = {
    id: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    sourceIcon: PropTypes.node.isRequired,
    authorizeIcon: PropTypes.node,
    userProfile: PropTypes.object,
    onSourceSelected: PropTypes.func.isRequired,
    onLogin: PropTypes.func,
    onLogout: PropTypes.func
};

export const Sources = (props) => {
    const { onSourceChanged, onLogin, onLogout } = props;
    const authIcons = [SvgUnauthorized, SvgUnauthorized, SvgUnauthorized, SvgUnauthorized, null];
    const icons = [SvgInstagram, SvgFacebook, SvgYoutube, SvgTikTok, SvgFile];

    return <>
        {
            props.context?.data && props.context.data.map((item, index) => {
                return <SourceItem
                    key={index}
                    id={`source-${index}`}
                    isActive={props.context.selectedIndex === index}
                    isEnabled={!!item.api}
                    sourceIcon={icons[index]}
                    authorizeIcon={authIcons[index]}
                    userProfile={item.userProfile}
                    onSourceSelected={onSourceChanged}
                    onLogin={onLogin}
                    onLogout={onLogout}
                    isReady={props.isReady}
                    loginComplete={item.loginComplete}
                />;
            })
        }
    </>;
}

Sources.propTypes = {
    context: PropTypes.object,
    onSourceChanged: PropTypes.func.isRequired,
    onLogin: PropTypes.func,
    onLogout: PropTypes.func
}
